export enum ArticleListType {
  Rows = 0,
  Cards = 1,
}
